import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ReferredOrders from '@/plugins/graphql/queries/v2/referral/referred-orders-with-count.gql';
import { standardDate } from '@/helpers/DateFormatter';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ReferredOrdersWithCount = class ReferredOrdersWithCount extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.referredOrders = null;
    }
    get headers() {
        return [
            {
                text: 'REFERENCE ID',
                value: 'referenceId',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PRODUCT NAME',
                value: 'referralName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CUSTOMER NAME',
                value: 'referralLink',
                align: 'left',
                sortable: false,
            },
            {
                text: 'TOTAL AMOUNT',
                value: 'dateCreated',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: 'PAYMENT METHOD',
                value: 'clicks',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ORDER DATE',
                value: 'referredCount',
                align: 'left',
                sortable: false,
            },
        ];
    }
    formattedPlacedAt(date) {
        return standardDate(date);
    }
    get queryOnFlight() {
        return this.$apollo.queries.referredOrders.loading;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ReferredOrdersWithCount.prototype, "uuid", void 0);
ReferredOrdersWithCount = __decorate([
    Component({
        apollo: {
            referredOrders: {
                query: ReferredOrders,
                variables() {
                    return {
                        referralLinkUuid: this.uuid,
                    };
                },
                update(data) {
                    return data.referredOrdersWithCount;
                },
            },
        },
    })
], ReferredOrdersWithCount);
export default ReferredOrdersWithCount;
